import { formatWithCommaSeparator } from 'pages/tradeIn/TradeInUtils';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

const CashPaymentView: React.FC = () => {
  const { vehicleData } = useSelector((state: RootState) => state.digitalRetailingStore);

  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  const toggleAccordion = (section: string) => {
    setOpenAccordion((prev) => (prev === section ? null : section));
  };

  const accordionData = [
    {
      id: 'totalTaxes',
      label: 'Total Taxes',
      value: '$0.00',
      details: [
        { label: 'State Tax', value: '$0.00' },
        { label: 'Local Tax', value: '$0.00' },
      ],
    },
    {
      id: 'additionalFees',
      label: 'Additional Fees',
      value: '$50.00',
      details: [
        { label: 'Service Fee', value: '$20.00' },
        { label: 'Delivery Fee', value: '$30.00' },
      ],
    },
  ];

  return (
    <>
      <div className='dr-payment-tile__vwl mb-4'>
        <div className='dr-payment-tile__vwl__lbl'>Total Cash Due</div>
        <div className='dr-payment-tile__vwl__value xl fw-500'>{`$${formatWithCommaSeparator(vehicleData?.MSR)}`}</div>
      </div>
      <ul className='dr-amt-summary list-unstyled mb-0'>
        <li>
          <div className='dr-amt-summary__lbl'>MSRP</div>
          <div className='dr-amt-summary__value'>{`$${formatWithCommaSeparator(vehicleData?.MSR)}`}</div>
        </li>
        {/* <li>
          <div className='dr-amt-summary__lbl'>Price Adjustment</div>
          <div className='dr-amt-summary__value'>+ $6,921.00</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Internet Price</div>
          <div className='dr-amt-summary__value'>$56,100</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Final Vehicle Price</div>
          <div className='dr-amt-summary__value'>$56,100</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Trade In (Net)</div>
          <div className='dr-amt-summary__value'>N/A</div>
        </li>
        <li>
          <div className='dr-amt-summary__lbl'>Total Fees</div>
          <div className='dr-amt-summary__value'>$0.00</div>
        </li> */}

        {/* {accordionData.map((accordion) => (
          <li key={accordion.id}>
            <div className='dr-amt-summary__accordion'>
              <div className='dr-amt-summary__accordion__header' onClick={() => toggleAccordion(accordion.id)}>
                <div className='dr-amt-summary__lbl'>{accordion.label}</div>
                <div className='dr-amt-summary__value'>{accordion.value}</div>
              </div>
              <div className={`dr-amt-summary__accordion__body ${openAccordion === accordion.id ? '' : 'hide'}`}>
                <ul className='dr-amt-summary list-unstyled mb-0'>
                  {accordion.details.map((detail, index) => (
                    <li key={index}>
                      <div className='dr-amt-summary__lbl'>{detail.label}</div>
                      <div className='dr-amt-summary__value'>{detail.value}</div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </li>
        ))} */}
      </ul>
    </>
  );
};

export default CashPaymentView;
